// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__33E4W","label":"PriceFilterPopup_label__2G22r","labelSelected":"PriceFilterPopup_labelSelected__2DBii"};